import { IconProps } from "../types/icon";

export const PlusIcon = ({
  className = "",
  size = 8,
  color = "currentColor",
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 8 8"
      aria-hidden="true"
      {...props}
    >
      <path
        stroke={color}
        strokeLinecap="round"
        strokeWidth="1.5"
        d="M4 1.25v5.5M1.25 4h5.5"
      />
    </svg>
  );
};
